import React from "react";
import { Container } from "@material-ui/core";
import Logo404 from "../../assets/images/404.png";

const Page404 = () => (
  <Container>
    <img src={Logo404} alt="Logo" />
  </Container>
);

export default Page404;
